import React, { useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as pabReplanningAction from '../../../../../actions/pabReplanningAction';
import HomeDefault from '../../../../../components/HomeDefaultComponent';
import { checkPermission } from '../../../../../services/auth';
import { PERMISSIONS } from '../../../../../utils/constants';
import { translate } from '../../../../../utils/util';
import * as actionsStock from '../../../../../actions/stockAction';

const SmallParts = (props) => {
    useEffect(() => {
        props.resetOrdesAll();
        // eslint-disable-next-line
    }, []);

    const menuSmallParts = () => {
        let menuItems = [];
        if (checkPermission(PERMISSIONS.PABReplanning.Access)) {
            menuItems = [...menuItems, { route: 'smallParts/filter', icon: 'mdi mdi-filter-outline', text: translate('lowering:lowering:filter') }];
            menuItems = [
                ...menuItems,
                {
                    route: {
                        pathname: 'smallParts/filter/order',
                        state: {
                            name: null,
                            icon: null,
                            label: null,
                            required: null,
                            route: 'smallParts/filter/order',
                            title: { icon: "mdi mdi-camera-timer", label: translate('lowering:lowering.iniciatePicking') }
                        }
                    },
                    icon: 'mdi mdi-cart-outline',
                    text: translate('lowering:lowering.iniciatePicking')
                }
            ];

            menuItems = [...menuItems, {
                route: {
                    pathname: '../warehousemanagement/stock/home',
                    state: {
                        pabReplanning: true
                    }
                }, icon: 'mdi mdi-arrow-down', text: translate('stock:write-off')
            }];

            menuItems = [...menuItems, {
                route: {
                    pathname: '../warehousemanagement/stock/search',
                    state: {
                        pabReplanning: true
                    }
                }, icon: 'mdi mdi-clipboard-list-outline', text: translate('stock:query'),
                onClick: () => props.clear()
            }];
        }
        return menuItems;
    };

    return (
        <HomeDefault menu={menuSmallParts()} title={{ icon: "mdi mdi-camera-timer", label: translate('menu:pabReplanning') }} subtitles={[]} />
    );
};

const mapStateToProps = () => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        resetOrdesAll: () => {
            dispatch(pabReplanningAction.resetOrdesAll());
        },
        clear: () => {
            dispatch(actionsStock.clearMaterials());
            dispatch(actionsStock.clearFilter());
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SmallParts)));


